import { lazyNamed } from 'src/utils/lazyNamed';

const Users = {
  UsersList: lazyNamed(() => import('./containers/UsersList'), 'UsersList'),
  UserForm: lazyNamed(() => import('./containers/UserForm'), 'UserForm'),
};

export default Users;
